export interface AddConnectorWizardState {
  connectorType: 'AWS_ACCOUNT_CONNECTOR' | 'GCP_PROJECT_CONNECTOR';
  awsAccountId: string;
  discoveryRoleName: string;
  dataAccessRoleName: string;
  gcpProjectId: string;
  discoveryServiceAccountName: string;
  dataAccessServiceAccountName: string;
  connectorName: string;
  workspaceId: string;
}

export const defaultAddConnectorWizardState: AddConnectorWizardState = {
  connectorType: 'AWS_ACCOUNT_CONNECTOR',
  awsAccountId: '',
  discoveryRoleName: 'EonDatalakeDiscoveryRole',
  dataAccessRoleName: 'EonDatalakeAccessRole',
  gcpProjectId: '',
  discoveryServiceAccountName: 'eon-datalake-discovery-sa',
  dataAccessServiceAccountName: 'eon-datalake-data-access-sa',
  connectorName: '',
  workspaceId: '',
};
